import { useState } from "react";
import { Label, Tag, Text as KonvaText, Rect } from "react-konva";

type PredictionBBoxProps = {
  bbox: number[];
  downscalePoint: (x: number, y: number) => [number, number];
  stroke: string;
  fill: string;
  confidence: number;
  type: string;
};

export function PredictionBBox({
  bbox,
  downscalePoint,
  stroke,
  fill,
  confidence,
  type,
}: PredictionBBoxProps) {
  const [hovered, setHovered] = useState(false);
  const [x, y] = downscalePoint(bbox[0], bbox[1]);
  const [w, h] = downscalePoint(bbox[2], bbox[3]);

  // Choose fill color based on hover state
  const fillColor = hovered ? undefined : fill;

  return (
    <>
      {hovered && (
        <Label x={x} y={y - 28}>
          <Tag fill={stroke} />
          <KonvaText
            text={`${type}: ${confidence.toFixed(2)}`}
            fontFamily="Arial"
            fontSize={14}
            padding={5}
            fill="black"
            fontStyle="bold"
          />
        </Label>
      )}
      <Rect
        x={x}
        y={y}
        width={w}
        height={h}
        stroke={stroke}
        strokeWidth={hovered ? 4 : 2}
        fill={fillColor}
        onPointerEnter={() => setHovered(true)}
        onPointerLeave={() => setHovered(false)}
      />
    </>
  );
}
